import { Component, Input, OnInit } from "@angular/core";
import { Resource } from "@lagoshny/ngx-hateoas-client";
import { ChildEntityDisplay } from "@app/view/shared/child-entity-display-resolver/child-entity-display";

@Component({
  selector: "app-child-entity-display",
  templateUrl: "./child-entity-display.component.html",
  styleUrls: ["./child-entity-display.component.scss"]
})
export class ChildEntityDisplayComponent implements OnInit, ChildEntityDisplay {
  displayValue: string = "";

  constructor() {}

  protected _resource: Resource;

  @Input()
  set resource(resource: Resource) {
    this._resource = resource;
  }

  protected _displayField: string;

  @Input()
  set displayField(displayField: string) {
    this._displayField = displayField;
  }

  protected _childType: new () => Resource;

  @Input()
  set childType(childType: new () => Resource) {
    this._childType = childType;
  }

  protected _relation: string;

  @Input()
  set relation(relation: string) {
    this._relation = relation;
  }

  ngOnInit() {
    this._resource
      ?.getRelation(this._relation)
      .subscribe((value) => (this.displayValue = value[this._displayField]));
  }
}
